import { connect, initializable } from "effects";
import * as functions from "./functions";
import Login from "./Login";

const mapStateToProps = (state, ownProps, getState) => {
  return {};
};

export default connect(initializable(Login), mapStateToProps, functions);
